export default "assets/marker-53a2e721.svg";